import { render, staticRenderFns } from "./ItemAttachment.vue?vue&type=template&id=dbd0a5e2"
import script from "./ItemAttachment.vue?vue&type=script&lang=js"
export * from "./ItemAttachment.vue?vue&type=script&lang=js"
import style0 from "./ItemAttachment.vue?vue&type=style&index=0&id=dbd0a5e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports